/**
 * Catálogo de prefijos telefónicos. Nombres vía i18n (clave ISO3).
 * Generado para NIF-519 (phone-input provisional portado desde identity-admin).
 * TODO: [NIF-519] Sustituir/retirar cuando el phone-input de Infinity cubra el catálogo.
 */
export interface PrefixCountryEntry {
	iso3: string;
	dialCode: string;
}

export const PREFIX_COUNTRIES: PrefixCountryEntry[] = [
	{ iso3: 'AFG', dialCode: '+93' },
	{ iso3: 'ALB', dialCode: '+355' },
	{ iso3: 'DZA', dialCode: '+213' },
	{ iso3: 'AND', dialCode: '+376' },
	{ iso3: 'AGO', dialCode: '+244' },
	{ iso3: 'ATG', dialCode: '+1' },
	{ iso3: 'ARG', dialCode: '+54' },
	{ iso3: 'ARM', dialCode: '+374' },
	{ iso3: 'AUS', dialCode: '+61' },
	{ iso3: 'AUT', dialCode: '+43' },
	{ iso3: 'AZE', dialCode: '+994' },
	{ iso3: 'BHR', dialCode: '+973' },
	{ iso3: 'BGD', dialCode: '+880' },
	{ iso3: 'BRB', dialCode: '+1' },
	{ iso3: 'BLR', dialCode: '+375' },
	{ iso3: 'BEL', dialCode: '+32' },
	{ iso3: 'BLZ', dialCode: '+501' },
	{ iso3: 'BEN', dialCode: '+229' },
	{ iso3: 'BTN', dialCode: '+975' },
	{ iso3: 'BOL', dialCode: '+591' },
	{ iso3: 'BIH', dialCode: '+387' },
	{ iso3: 'BWA', dialCode: '+267' },
	{ iso3: 'BRA', dialCode: '+55' },
	{ iso3: 'BRN', dialCode: '+673' },
	{ iso3: 'BGR', dialCode: '+359' },
	{ iso3: 'BFA', dialCode: '+226' },
	{ iso3: 'BDI', dialCode: '+257' },
	{ iso3: 'CPV', dialCode: '+238' },
	{ iso3: 'KHM', dialCode: '+855' },
	{ iso3: 'CMR', dialCode: '+237' },
	{ iso3: 'CAN', dialCode: '+1' },
	{ iso3: 'CAF', dialCode: '+236' },
	{ iso3: 'TCD', dialCode: '+235' },
	{ iso3: 'CHL', dialCode: '+56' },
	{ iso3: 'CHN', dialCode: '+86' },
	{ iso3: 'COL', dialCode: '+57' },
	{ iso3: 'COM', dialCode: '+269' },
	{ iso3: 'COG', dialCode: '+242' },
	{ iso3: 'COD', dialCode: '+243' },
	{ iso3: 'CRI', dialCode: '+506' },
	{ iso3: 'HRV', dialCode: '+385' },
	{ iso3: 'CUB', dialCode: '+53' },
	{ iso3: 'CYP', dialCode: '+357' },
	{ iso3: 'CZE', dialCode: '+420' },
	{ iso3: 'CIV', dialCode: '+225' },
	{ iso3: 'DNK', dialCode: '+45' },
	{ iso3: 'DJI', dialCode: '+253' },
	{ iso3: 'DMA', dialCode: '+1' },
	{ iso3: 'DOM', dialCode: '+1' },
	{ iso3: 'ECU', dialCode: '+593' },
	{ iso3: 'EGY', dialCode: '+20' },
	{ iso3: 'SLV', dialCode: '+503' },
	{ iso3: 'GNQ', dialCode: '+240' },
	{ iso3: 'ERI', dialCode: '+291' },
	{ iso3: 'EST', dialCode: '+372' },
	{ iso3: 'SWZ', dialCode: '+268' },
	{ iso3: 'ETH', dialCode: '+251' },
	{ iso3: 'FJI', dialCode: '+679' },
	{ iso3: 'FIN', dialCode: '+358' },
	{ iso3: 'FRA', dialCode: '+33' },
	{ iso3: 'GAB', dialCode: '+241' },
	{ iso3: 'GMB', dialCode: '+220' },
	{ iso3: 'GEO', dialCode: '+995' },
	{ iso3: 'DEU', dialCode: '+49' },
	{ iso3: 'GHA', dialCode: '+233' },
	{ iso3: 'GRC', dialCode: '+30' },
	{ iso3: 'GRD', dialCode: '+1' },
	{ iso3: 'GTM', dialCode: '+502' },
	{ iso3: 'GIN', dialCode: '+224' },
	{ iso3: 'GNB', dialCode: '+245' },
	{ iso3: 'GUY', dialCode: '+592' },
	{ iso3: 'HTI', dialCode: '+509' },
	{ iso3: 'HND', dialCode: '+504' },
	{ iso3: 'HUN', dialCode: '+36' },
	{ iso3: 'ISL', dialCode: '+354' },
	{ iso3: 'IND', dialCode: '+91' },
	{ iso3: 'IDN', dialCode: '+62' },
	{ iso3: 'IRN', dialCode: '+98' },
	{ iso3: 'IRQ', dialCode: '+964' },
	{ iso3: 'IRL', dialCode: '+353' },
	{ iso3: 'ISR', dialCode: '+972' },
	{ iso3: 'ITA', dialCode: '+39' },
	{ iso3: 'JAM', dialCode: '+1' },
	{ iso3: 'JPN', dialCode: '+81' },
	{ iso3: 'JOR', dialCode: '+962' },
	{ iso3: 'KAZ', dialCode: '+7' },
	{ iso3: 'KEN', dialCode: '+254' },
	{ iso3: 'KIR', dialCode: '+686' },
	{ iso3: 'PRK', dialCode: '+850' },
	{ iso3: 'KOR', dialCode: '+82' },
	{ iso3: 'KWT', dialCode: '+965' },
	{ iso3: 'KGZ', dialCode: '+996' },
	{ iso3: 'LAO', dialCode: '+856' },
	{ iso3: 'LVA', dialCode: '+371' },
	{ iso3: 'LBN', dialCode: '+961' },
	{ iso3: 'LSO', dialCode: '+266' },
	{ iso3: 'LBR', dialCode: '+231' },
	{ iso3: 'LBY', dialCode: '+218' },
	{ iso3: 'LIE', dialCode: '+423' },
	{ iso3: 'LTU', dialCode: '+370' },
	{ iso3: 'LUX', dialCode: '+352' },
	{ iso3: 'MDG', dialCode: '+261' },
	{ iso3: 'MWI', dialCode: '+265' },
	{ iso3: 'MYS', dialCode: '+60' },
	{ iso3: 'MDV', dialCode: '+960' },
	{ iso3: 'MLI', dialCode: '+223' },
	{ iso3: 'MLT', dialCode: '+356' },
	{ iso3: 'MHL', dialCode: '+692' },
	{ iso3: 'MRT', dialCode: '+222' },
	{ iso3: 'MUS', dialCode: '+230' },
	{ iso3: 'MEX', dialCode: '+52' },
	{ iso3: 'FSM', dialCode: '+691' },
	{ iso3: 'MDA', dialCode: '+373' },
	{ iso3: 'MCO', dialCode: '+377' },
	{ iso3: 'MNG', dialCode: '+976' },
	{ iso3: 'MNE', dialCode: '+382' },
	{ iso3: 'MAR', dialCode: '+212' },
	{ iso3: 'MOZ', dialCode: '+258' },
	{ iso3: 'MMR', dialCode: '+95' },
	{ iso3: 'NAM', dialCode: '+264' },
	{ iso3: 'NRU', dialCode: '+674' },
	{ iso3: 'NPL', dialCode: '+977' },
	{ iso3: 'NLD', dialCode: '+31' },
	{ iso3: 'NZL', dialCode: '+64' },
	{ iso3: 'NIC', dialCode: '+505' },
	{ iso3: 'NER', dialCode: '+227' },
	{ iso3: 'NGA', dialCode: '+234' },
	{ iso3: 'MKD', dialCode: '+389' },
	{ iso3: 'NOR', dialCode: '+47' },
	{ iso3: 'OMN', dialCode: '+968' },
	{ iso3: 'PAK', dialCode: '+92' },
	{ iso3: 'PLW', dialCode: '+680' },
	{ iso3: 'PAN', dialCode: '+507' },
	{ iso3: 'PNG', dialCode: '+675' },
	{ iso3: 'PRY', dialCode: '+595' },
	{ iso3: 'PER', dialCode: '+51' },
	{ iso3: 'PHL', dialCode: '+63' },
	{ iso3: 'POL', dialCode: '+48' },
	{ iso3: 'PRT', dialCode: '+351' },
	{ iso3: 'QAT', dialCode: '+974' },
	{ iso3: 'ROU', dialCode: '+40' },
	{ iso3: 'RUS', dialCode: '+7' },
	{ iso3: 'RWA', dialCode: '+250' },
	{ iso3: 'KNA', dialCode: '+1' },
	{ iso3: 'LCA', dialCode: '+1' },
	{ iso3: 'VCT', dialCode: '+1' },
	{ iso3: 'WSM', dialCode: '+685' },
	{ iso3: 'SMR', dialCode: '+378' },
	{ iso3: 'STP', dialCode: '+239' },
	{ iso3: 'SAU', dialCode: '+966' },
	{ iso3: 'SEN', dialCode: '+221' },
	{ iso3: 'SRB', dialCode: '+381' },
	{ iso3: 'SYC', dialCode: '+248' },
	{ iso3: 'SLE', dialCode: '+232' },
	{ iso3: 'SGP', dialCode: '+65' },
	{ iso3: 'SVK', dialCode: '+421' },
	{ iso3: 'SVN', dialCode: '+386' },
	{ iso3: 'SLB', dialCode: '+677' },
	{ iso3: 'SOM', dialCode: '+252' },
	{ iso3: 'ZAF', dialCode: '+27' },
	{ iso3: 'SSD', dialCode: '+211' },
	{ iso3: 'ESP', dialCode: '+34' },
	{ iso3: 'LKA', dialCode: '+94' },
	{ iso3: 'SDN', dialCode: '+249' },
	{ iso3: 'SUR', dialCode: '+597' },
	{ iso3: 'SWE', dialCode: '+46' },
	{ iso3: 'CHE', dialCode: '+41' },
	{ iso3: 'SYR', dialCode: '+963' },
	{ iso3: 'TJK', dialCode: '+992' },
	{ iso3: 'TZA', dialCode: '+255' },
	{ iso3: 'THA', dialCode: '+66' },
	{ iso3: 'TLS', dialCode: '+670' },
	{ iso3: 'TGO', dialCode: '+228' },
	{ iso3: 'TON', dialCode: '+676' },
	{ iso3: 'TTO', dialCode: '+1' },
	{ iso3: 'TUN', dialCode: '+216' },
	{ iso3: 'TUR', dialCode: '+90' },
	{ iso3: 'TKM', dialCode: '+993' },
	{ iso3: 'TUV', dialCode: '+688' },
	{ iso3: 'UGA', dialCode: '+256' },
	{ iso3: 'UKR', dialCode: '+380' },
	{ iso3: 'ARE', dialCode: '+971' },
	{ iso3: 'GBR', dialCode: '+44' },
	{ iso3: 'USA', dialCode: '+1' },
	{ iso3: 'URY', dialCode: '+598' },
	{ iso3: 'UZB', dialCode: '+998' },
	{ iso3: 'VUT', dialCode: '+678' },
	{ iso3: 'VEN', dialCode: '+58' },
	{ iso3: 'VNM', dialCode: '+84' },
	{ iso3: 'YEM', dialCode: '+967' },
	{ iso3: 'ZMB', dialCode: '+260' },
	{ iso3: 'ZWE', dialCode: '+263' },
];
